import React from 'react';
import { HorizontalSeparator } from '@cld/separator';

export const Separator = () => <HorizontalSeparator />;
